import React, { useRef } from 'react';
import classNames from 'classnames';
import styles from './DesktopMenuItem.scss';
import { formatTestId } from '../../../utils/test-id/format-testid';

type DesktopMenuItemProps = {
  label: string;
  url: string;
  active: boolean;
  onSelect: () => void;
  onClose: () => void;
  isTouch: boolean;
  tabIndex?: number;
  onNavigate?: (direction: string) => void;
  onTabNavigate?: (event: React.KeyboardEvent<HTMLElement>) => void;
  onEnterSelect?: () => void;
  hasChildData?: boolean;
};

export const DesktopMenuItem = ({
  label,
  url,
  active,
  onSelect,
  isTouch,
  tabIndex = 0,
  onTabNavigate = () => {},
  onEnterSelect = () => {},
  hasChildData = false,
}: DesktopMenuItemProps) => {
  const handleOnClick = () => {
    onSelect();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Escape') {
      onTabNavigate(e);
      return;
    }

    if (e.key === 'Tab') {
      onTabNavigate(e);
      return;
    }

    if (e.key !== 'Enter') {
      return;
    }

    e.preventDefault();
    onEnterSelect();
  };

  const liRef = useRef(null);

  const onMouseEnterHandlers = {
    onMouseEnter: onSelect,
  };

  const cn = classNames(styles.desktopMenuItem, {
    [styles.desktopMenuItem__active]: active,
  });

  const Element = hasChildData ? 'button' : 'a';

  return (
    <li
      className={cn}
      ref={liRef}
      {...(!isTouch && { ...onMouseEnterHandlers })}
      data-testid={formatTestId(label, 'nav-')}
      suppressHydrationWarning
    >
      <Element
        className={classNames(styles.desktopMenuItemLink)}
        href={url}
        {...(isTouch && { onClick: handleOnClick })}
        onKeyDown={handleKeyDown}
        tabIndex={tabIndex}
        id={formatTestId(label, 'desktop-menu-item-')}
        suppressHydrationWarning
      >
        {label}
      </Element>
    </li>
  );
};
